/* HQ Forged Wheels — Stealth theme interactions */
(function () {
  'use strict';

  // Scroll-reveal animation
  var reveal = function () {
    var els = document.querySelectorAll('.st-reveal:not(.st-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('st-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('st-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  };

  // Finish swatch showcase toggle (homepage)
  var finishes = function () {
    var opts = document.querySelectorAll('.st-finopt');
    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        opts.forEach(function (x) { x.classList.remove('st-finopt--on'); });
        opt.classList.add('st-finopt--on');
      });
    });
  };

  // Dark / light theme toggle
  var themeToggle = function () {
    document.querySelectorAll('[data-theme-toggle]').forEach(function (btn) {
      if (btn.dataset.themeBound) return;
      btn.dataset.themeBound = '1';
      btn.addEventListener('click', function () {
        var cur = document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
        var next = cur === 'light' ? 'dark' : 'light';
        document.documentElement.setAttribute('data-theme', next);
        try { localStorage.setItem('hqfw-theme', next); } catch (e) {}
        var meta = document.querySelector('meta[name="theme-color"]');
        if (meta) meta.setAttribute('content', next === 'light' ? '#f4f4f5' : '#0a0a0b');
      });
    });
  };

  // PDP configurator — colour swatches + image thumbnails
  var pdpConfig = function () {
    document.querySelectorAll('[data-color-swatches]').forEach(function (group) {
      if (group.dataset.bound) return;
      group.dataset.bound = '1';
      var field = group.closest('.st-pdp__field') || group.parentElement;
      var input = field ? field.querySelector('[data-color-input]') : null;
      var output = field ? field.querySelector('[data-finish-output]') : null;
      var swatches = group.querySelectorAll('[data-color]');
      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          swatches.forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
          sw.setAttribute('aria-checked', 'true');
          if (input) input.value = sw.dataset.color;
          if (output) output.textContent = sw.dataset.color;
        });
      });
    });
    // PDP gallery — smooth sliding track (touch swipe + desktop trackpad)
    var stage = document.querySelector('[data-pdp-stage]');
    var ptrack = stage ? stage.querySelector('[data-pdp-track]') : null;
    if (stage && ptrack && !stage.dataset.bound) {
      stage.dataset.bound = '1';
      var count = ptrack.children.length;
      var pthumbs = Array.prototype.slice.call(document.querySelectorAll('[data-pdp-thumb]'));
      var pidx = 0;
      var pgo = function (i) {
        if (count < 1) return;
        pidx = ((i % count) + count) % count;
        ptrack.style.transform = 'translateX(' + (-pidx * 100) + '%)';
        pthumbs.forEach(function (t, ti) { t.setAttribute('aria-current', ti === pidx ? 'true' : 'false'); });
      };
      pthumbs.forEach(function (t, i) { t.addEventListener('click', function () { pgo(i); }); });
      if (count > 1) {
        var psx = null;
        stage.addEventListener('touchstart', function (e) { psx = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (psx === null) return;
          var dx = e.changedTouches[0].clientX - psx;
          if (Math.abs(dx) > 40) pgo(pidx + (dx < 0 ? 1 : -1));
          psx = null;
        }, { passive: true });
        // desktop trackpad — horizontal two-finger swipe (wheel deltaX)
        var pLock = false, pAcc = 0;
        stage.addEventListener('wheel', function (e) {
          if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
          e.preventDefault();
          if (pLock) return;
          pAcc += e.deltaX;
          if (Math.abs(pAcc) < 30) return;
          pgo(pidx + (pAcc > 0 ? 1 : -1));
          pAcc = 0; pLock = true;
          setTimeout(function () { pLock = false; }, 500);
        }, { passive: false });
      }
    }
  };

  // Collection card — swipe through a product's images (tap still opens the product)
  var cardSwipe = function () {
    document.querySelectorAll('[data-card-swipe]').forEach(function (box) {
      if (box.dataset.bound) return;
      var track = box.querySelector('.st-card__track');
      if (!track) return;
      var slides = track.children.length;
      if (slides < 2) return;
      box.dataset.bound = '1';
      var dots = Array.prototype.slice.call(box.querySelectorAll('.st-card__dot'));
      var idx = 0, sx = null, sy = null, swiped = false;
      var go = function (i) {
        idx = Math.max(0, Math.min(slides - 1, i));
        track.style.transform = 'translateX(' + (-idx * 100) + '%)';
        dots.forEach(function (d, di) { d.classList.toggle('is-on', di === idx); });
      };
      box.addEventListener('touchstart', function (e) {
        sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiped = false;
      }, { passive: true });
      box.addEventListener('touchmove', function (e) {
        if (sx === null) return;
        var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
        if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) swiped = true;
      }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
        sx = null;
      }, { passive: true });
      // desktop trackpad — horizontal two-finger swipe (wheel deltaX)
      var wLock = false, wAcc = 0;
      box.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        e.preventDefault();
        if (wLock) return;
        wAcc += e.deltaX;
        if (Math.abs(wAcc) < 30) return;
        go(idx + (wAcc > 0 ? 1 : -1));
        wAcc = 0; wLock = true;
        setTimeout(function () { wLock = false; }, 450);
      }, { passive: false });
      var link = box.closest('a');
      if (link) link.addEventListener('click', function (e) {
        if (swiped) { e.preventDefault(); swiped = false; }
      });
    });
  };

  // Lifestyle slider — auto-cycle with crossfade, dot navigation
  var slider = function () {
    document.querySelectorAll('[data-slider]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var slides = Array.prototype.slice.call(root.querySelectorAll('.st-slider__slide'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('.st-slider__dot'));
      if (slides.length < 2) return;
      var idx = 0;
      var n = slides.length;
      var timer;
      var go = function (i) {
        slides[idx].classList.remove('st-slider__slide--active');
        if (dots[idx]) dots[idx].setAttribute('aria-current', 'false');
        idx = ((i % n) + n) % n;
        slides[idx].classList.add('st-slider__slide--active');
        if (dots[idx]) dots[idx].setAttribute('aria-current', 'true');
      };
      var restart = function () {
        clearInterval(timer);
        timer = setInterval(function () { go(idx + 1); }, 5500);
      };
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { go(i); restart(); });
      });
      var prev = root.querySelector('[data-slider-prev]');
      var next = root.querySelector('[data-slider-next]');
      if (prev) prev.addEventListener('click', function () { go(idx - 1); restart(); });
      if (next) next.addEventListener('click', function () { go(idx + 1); restart(); });
      restart();
    });
  };

  var finishTabs = function () {
    var tabs = document.querySelectorAll('[data-finish-tab]');
    if (tabs.length === 0) return;
    tabs.forEach(function (tab) {
      if (tab.dataset.bound) return;
      tab.dataset.bound = '1';
      tab.addEventListener('click', function () {
        var group = tab.dataset.finishTab;
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        document.querySelectorAll('[data-finish-group]').forEach(function (g) {
          if (g.dataset.finishGroup === group) g.removeAttribute('hidden');
          else g.setAttribute('hidden', '');
        });
      });
    });
  };

  var inquiryModal = function () {
    var modal = document.querySelector('[data-inquiry-modal]');
    if (!modal) return;
    var body = modal.querySelector('#InquiryBody');
    var open = function () {
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var firstInput = modal.querySelector('input[name="contact[name]"]');
      if (firstInput) setTimeout(function () { firstInput.focus(); }, 50);
    };
    var close = function () {
      modal.setAttribute('hidden', '');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };
    document.querySelectorAll('[data-inquiry-trigger]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        // Serialize the PDP configurator form into a readable message
        var form = btn.closest('[data-pdp-form]');
        if (form && body) {
          var lines = [];
          var title = form.dataset.productTitle || '';
          var url = form.dataset.productUrl || '';
          if (title) lines.push('Modell: ' + title);
          if (url) lines.push('Link: ' + url);
          lines.push('');
          lines.push('Konfiguration:');
          form.querySelectorAll('[name^="properties["]').forEach(function (input) {
            var match = input.name.match(/properties\[(.+?)\]/);
            if (!match) return;
            var key = match[1];
            var val = input.value || '';
            if (val) lines.push('• ' + key + ': ' + val);
          });
          lines.push('');
          lines.push('Nachricht:');
          body.value = lines.join('\n');
        }
        open();
      });
    });
    modal.querySelectorAll('[data-inquiry-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) close();
    });
    // If the form just posted successfully, auto-open the modal so the user sees the thank-you state.
    if (window.location.search.indexOf('contact_posted=true') !== -1
        || modal.querySelector('.st-inq__ok')) {
      open();
    }
  };

  var init = function () { reveal(); finishes(); themeToggle(); pdpConfig(); finishTabs(); inquiryModal(); slider(); cardSwipe(); };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-run when sections are edited in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
